var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.job
    ? _c("ul", { staticClass: "list-group" }, [
        _c("li", { staticClass: "list-group-item" }, [
          _vm._v("ID: " + _vm._s(_vm.job.id)),
        ]),
        _vm._v(" "),
        _vm.job && _vm.job.status
          ? _c("li", { staticClass: "list-group-item" }, [
              _vm._v("\n\t\tEtat:\n\t\t"),
              _vm.job.status == "scheduled"
                ? _c("span", [_vm._v("planifié")])
                : _vm.job.status == "finished"
                ? _c("span", [_vm._v("terminé")])
                : _c("span", [_vm._v(_vm._s(_vm.job.status))]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("li", { staticClass: "list-group-item" }, [
          _c(
            "a",
            {
              attrs: {
                target: "_blank",
                href: _vm.job.deliveries[0].tracking_url,
              },
            },
            [_vm._v("Carte en temps réel")]
          ),
        ]),
        _vm._v(" "),
        _vm.UrlService.includes("admin2") ||
        _vm.UrlService.includes("admin") ||
        _vm.UrlService.includes("admin1")
          ? _c("li", { staticClass: "list-group-item" }, [
              _c(
                "a",
                {
                  staticClass:
                    "tagIcon-bo-p1 color-bo-p1 hover-color-bo-p1 hover-opacity w-100",
                  staticStyle: { width: "100%" },
                  attrs: { target: "_blank", href: _vm.stuartUrl },
                },
                [
                  _c("i", { staticClass: "fie-icon_delivery" }),
                  _vm._v(" "),
                  _c("div", { staticStyle: { margin: "0 !important" } }, [
                    _vm._v(
                      "\n\t\t\t\tDétails livraison sur le site Stuart\n\t\t\t"
                    ),
                  ]),
                ]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("li", { staticClass: "list-group-item" }, [
          _vm._v(
            "Point de retrait: " +
              _vm._s(_vm.job.deliveries[0].pickup.address.formatted_address)
          ),
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "list-group-item" }, [
          _vm._v(
            "Retrait prévu à: " +
              _vm._s(_vm.moment(_vm.job.pickup_at).format("HH:mm"))
          ),
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "list-group-item" }, [
          _vm._v(
            "Retrait effectué à: " +
              _vm._s(
                _vm.moment(_vm.job.deliveries[0].picked_at).format("HH:mm")
              )
          ),
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "list-group-item" }, [
          _vm._v(
            "Point de livraison: " +
              _vm._s(_vm.job.deliveries[0].dropoff.address.formatted_address)
          ),
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "list-group-item" }, [
          _vm._v(
            "Livraison prévue à: " +
              _vm._s(_vm.moment(_vm.job.dropoff_at).format("HH:mm"))
          ),
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "list-group-item" }, [
          _vm._v(
            "Livraison effectuée à: " +
              _vm._s(
                _vm.moment(_vm.job.deliveries[0].delivered_at).format("HH:mm")
              )
          ),
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "list-group-item" }, [
          _vm._v("\n\t\tLivreur: "),
          _vm.job.driver
            ? _c("span", [
                _vm._v(
                  _vm._s(_vm.job.driver.display_name) +
                    " " +
                    _vm._s(_vm.job.driver.phone)
                ),
              ])
            : _vm._e(),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }